const permissionApi = {
  GETPERMISSIONLISTALL: 'CSVPA-China/api/permissions/getListAll', //所有权限
  setPermissions: 'CSVPA-China/api/user/setPermissions' //设置员工权限
}

export default permissionApi
